import { gql } from '@apollo/client';
import {
  DataTableConfigFieldsFragment,
  FunnelConfigFieldsFragment,
  PathConfigFieldsFragment,
  QueryConfigFieldsFragment,
  RetentionConfigFieldsFragment,
} from './fragments';
import { SignificanceConfigFieldsFragment } from '../significance/significanceConfig';
import { CohortConfigFragment } from '../cohorts';
import {
  DatePickerFieldsFragment,
  LogicalOperatorFragment,
} from '../fragments';

export const GET_QUERY_CONFIG = gql`
  query QueryConfig($schemaId: ID!) {
    queryConfig(schemaId: $schemaId) {
      ...QueryConfigFields
    }
  }
  ${QueryConfigFieldsFragment}
`;

export const GET_FUNNEL_CONFIG = gql`
  query FunnelConfig($schemaId: ID!) {
    funnelConfig(schemaId: $schemaId) {
      ...FunnelConfigFields
    }
  }
  ${FunnelConfigFieldsFragment}
`;

export const GET_DATA_TABLE_CONFIG = gql`
  query DataTableConfig($schemaId: ID!) {
    dataTableConfig(schemaId: $schemaId) {
      ...DataTableConfigFields
    }
  }
  ${DataTableConfigFieldsFragment}
`;

export const GET_PATH_CONFIG = gql`
  query PathConfig($schemaId: ID!) {
    pathConfig(schemaId: $schemaId) {
      ...PathConfigFields
    }
  }
  ${PathConfigFieldsFragment}
`;

export const GET_RETENTION_CONFIG = gql`
  query RetentionConfig($schemaId: ID!) {
    retentionConfig(schemaId: $schemaId) {
      ...RetentionConfigFields
    }
  }
  ${RetentionConfigFieldsFragment}
`;

export const GET_SIGNIFICANCE_CONFIG = gql`
  query SignificanceConfig($schemaId: ID!) {
    significanceConfig(schemaId: $schemaId) {
      ...SignificanceConfigFields
    }
  }
  ${SignificanceConfigFieldsFragment}
`;

export const GET_PREDICTION_CONFIG = gql`
  query PredictionConfig($schemaId: ID!) {
    predictionConfig(schemaId: $schemaId) {
      defaultStart
      defaultEnd
      liveStartDate
      timezone
      logicOps {
        ...LogicalOperatorFields
      }
      cohortConfig {
        ...CohortConfigFields
      }
      defaultDatePicker {
        ...DatePickerFields
      }
    }
  }
  ${CohortConfigFragment}
  ${LogicalOperatorFragment}
  ${DatePickerFieldsFragment}
`;
